import { Icon } from '@ksyos/design-system';
import { Link } from '../../atoms/link/Link';

export function DropdownLink(props: { labelLess: string; labelMore: string; onClick: () => void; open: boolean }) {
    return (
        <Link
            collapse
            linkColor="muted"
            onClick={(e) => {
                e.preventDefault();
                if (props.onClick) {
                    props.onClick();
                }
            }}
            to="#"
        >
            {props.open ? (
                <>
                    <Icon
                        color="minimal"
                        icon="caret-up"
                    />
                    {props.labelLess}
                </>
            ) : (
                <>
                    <Icon
                        color="minimal"
                        icon="caret-down"
                    />{' '}
                    {props.labelMore}
                </>
            )}
        </Link>
    );
}
